import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import GoogleBigQueryReaderForm from '../forms/google-big-query-reader-form';
import { googleBigQueryReaderValidationSchema } from '../schema/googleBigQueryReader.js';

export default function GoogleBigQueryReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Google BigQuery Reader Node Details',
        altText: 'Google BigQuery Reader Node',
        defaultLabel: 'Google BigQuery Reader Node',
      }}
    >
      <CommonNode
        FormComponent={GoogleBigQueryReaderForm}
        schemaResolver={googleBigQueryReaderValidationSchema}
      />
    </NodeProvider>
  );
}
